export class ColorLogger {
  private static readonly BROWSER_COLORS = [
    '#E91E63',
    '#9C27B0',
    '#3F51B5',
    '#03A9F4',
    '#00BCD4',
    '#009688',
    '#4CAF50',
    '#8BC34A',
    '#CDDC39',
    '#FFC107',
    '#FF9800',
    '#FF5722',
    '#607D8B',
    '#795548',
    '#1890ff',
    '#52c41a',
    '#faad14',
  ];
  private static readonly SYMBOLS = ['#', '>', '='];
  // 不考虑 Node 环境，移除 ANSI 配置

  private static _indexByNamespace(ns: string, paletteLen: number): number {
    const trimmed = (ns || '').trim();
    const first = trimmed[0] || 'a';
    const code = first.toLowerCase().charCodeAt(0);
    // a-z => 0-25；其他字符做简单散列
    const base =
      code >= 97 && code <= 122
        ? code - 97
        : Array.from(trimmed).reduce((s, ch) => s + ch.charCodeAt(0), 0) % 26;
    return base % Math.max(1, paletteLen);
  }

  constructor(namespace: string) {
    // 保存命名空间
    this._namespace = namespace;
    // 颜色：根据 namespace 首字母索引选择
    const cIdx = ColorLogger._indexByNamespace(
      namespace,
      ColorLogger.BROWSER_COLORS.length
    );
    this._color = ColorLogger.BROWSER_COLORS[cIdx];
    this._style = `color: ${this._color}; font-weight: 600;`;
    // 符号：根据 namespace 首字母索引选择
    const sIdx = ColorLogger._indexByNamespace(
      namespace,
      ColorLogger.SYMBOLS.length
    );
    this._symbol = ColorLogger.SYMBOLS[sIdx];
  }

  private readonly _namespace: string;
  private _color: string;
  private _style: string;
  private _symbol: string;

  log(message: any, ...args: any[]) {
    // 如果第一个参数是字符串且包含符号，则生成 16 个重复符号的标题行
    const header = (typeof message === 'string' && ColorLogger.SYMBOLS.find(s => message.startsWith(s))?.repeat(32)) || '';

    // 将后续参数统一处理为字符串，并在末尾追加换行
    const lines = args.map(l => (typeof l === 'string' ? l + '\n' : l));

    // 输出带颜色样式的日志：头部着色，正文默认样式
    console.log(
      `%c[${this._namespace}]  ${header}\n${message}  :%c`,
      this._style,
      '',
      ...lines
    );
  }

  namespace(extra: string) {
    return new ColorLogger(`${this._namespace}:${extra}`);
  }

  static from(namespace: string) {
    return new ColorLogger(namespace);
  }
}
